import { useState } from "react";

import cn from "@utils/cn";
import { Router, getIconProps } from "@utils";
import Icon from "@elements/Icon";
import NavbarDrawer from "@components/navbar/NavbarDrawer";

const CLASS_NAME = cn(`
  flex
  items-center
  justify-center
  w-12
  h-12
  rounded-2xl
  transition-all
  duration-200

  text-(--navbar-foreground-color)

  hover:bg-black/20

  focus:bg-black/20
  focus:outline-none

  active:bg-black/30
`);

const MobileNavbarItem = (props) => {
  const {
    label,
    onClick,
    tooltip,
  } = props;

  const iconProps = getIconProps(label.icon, {
    fixedWidth: true,
    size: "lg",
  });

  return (
    <button
      className={CLASS_NAME}
      onClick={onClick}
      aria-label={tooltip}
    >
      {label.icon && (
        <Icon {...iconProps} />
      )}
    </button>
  );
};

export default function MobileNavbar(_props) {
  const [isDrawerExpanded, setIsDrawerExpanded] = useState(false);

  const {
    currentUserUnreadNotificationsCount,
    currentUserIncompleteAssignedTasksCount,
  } = window.appContext;

  const hasUnreadNotifications = currentUserUnreadNotificationsCount > 0;
  const hasIncompleteAssignedTasks = currentUserIncompleteAssignedTasksCount > 0;

  const items = [
    {
      label: {
        icon: "bars",
      },
      onClick: () => setIsDrawerExpanded(true),
      tooltip: "Menu",
    },
    {
      label: {
        icon: "atom-simple",
      },
      onClick: () => Router.redirectToPath("/"),
      tooltip: "Home",
    },
    {
      label: {
        icon: {
          name: "hexagon-check",
          color: hasIncompleteAssignedTasks ? "#FFCB00" : "#FFFFFF",
        },
      },
      onClick: () => Router.redirectToPath("/tasks"),
      tooltip: "Tasks",
    },
    {
      label: {
        icon: {
          name: hasUnreadNotifications ? "bell-exclamation" : "bell",
          color: hasUnreadNotifications ? "#FFCB00" : "#FFFFFF",
        },
      },
      onClick: () => Router.redirectToPath("/notifications"),
      tooltip: "Inbox",
    },
  ];

  return (
    <>
      <NavbarDrawer
        isExpanded={isDrawerExpanded}
        setIsExpanded={setIsDrawerExpanded}
      />

      <nav className="fixed bottom-0 inset-x-0 z-30 bg-(--navbar-background-color) shadow-navbar md:hidden pr-24">
        <div className="flex items-center justify-around h-16">
          {items.map((item, index) => (
            <MobileNavbarItem
              key={index}
              label={item.label}
              onClick={item.onClick}
              tooltip={item.tooltip}
            />
          ))}
        </div>
      </nav>
    </>
  );
}
